import { lazy } from "react";
import { paths } from "~/router/paths";
import { app } from "~/helpers/routes";

const BackgroundRemoverPage = lazy(() => import("~/pages/background-remover"));

export const routes: Array<any> = [
  {
    path: paths["background-remover"].index,
    element: app(BackgroundRemoverPage),
  },
];
